import React, { useRef, useState, useEffect } from 'react';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import * as loadings from '../../../constants/loadings/user';
import * as R from 'ramda';
import { ToasterConfigurations } from '../../../constants/toasterText/configurations';
import { toast } from 'react-toastify';

import { Header } from './../_common/header';
import { useDispatch, useSelector } from 'react-redux';

import { RegexFields } from '../../../constants/utils/regexFields';
import * as Loadings from '../../../constants/loadings/auth';
import { registerUser, resetAuth, sendOTPCode, verifyOTPCode } from '../../../actions/auth-api';
import { resetUser, updateUserSecurity, changePhoneNumber, updateUser, deleteUser } from '../../../actions/user-api';

import { LoadingState } from '../../../_common/loadingState';
import { DeleteUser } from '../../_common/deleteUser';


export const SettingsProfil = ({ isLoading }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

    const user = useSelector(state => state.user);
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();

    //phone
    const [modifyNumber, setModifyNumber] = useState(false);
    const [ignoreTmp, setIgnoreTmp] = useState(false);
    const [isOnFocus, setIsOnFocus] = useState(false);
    const [tmpPhoneConfirmed, setTmpPhoneConfirmed] = useState(false);
    const [wasSendOnce, setWasSendOnce] = useState(false);

    //email
    const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
    const [wasValidated, setWasValidated] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [passwordsMatch, setPasswordsMatch] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);


    const codeRef = useRef(null);
    const formInfoRef = useRef(null);
    const credentialsForm = useRef(null);
    const securityForm = useRef(null);

    let parsedPhoneNumber = undefined;
    if (!R.isNil(user.user) && !R.isNil(user.user.phoneNumber)) {
        parsedPhoneNumber = parsePhoneNumber(user.user.phoneNumber);
    }


    const [credentials, setCredentials] = useState({
        email: !R.isNil(user.user) && !R.isNil(user.user.email) ? user.user.email : '',
        currentPassword: '',
        password: '',
        confirmPassword: '',
        phoneNumber: R.isNil(parsedPhoneNumber) ? '' : parsedPhoneNumber.nationalNumber,
        countryCode: R.isNil(parsedPhoneNumber) ? '' : parsedPhoneNumber.countryCallingCode,
        phoneCountry: R.isNil(parsedPhoneNumber) ? '' : parsedPhoneNumber.country,
    });



    const [personalData, setPersonalData] = useState({
        gender: !R.isNil(user.user) && !R.isNil(user.user.gender) ? user.user.gender : undefined,
        firstName: !R.isNil(user.user) && !R.isNil(user.user.firstName) ? user.user.firstName : '',
        lastName: !R.isNil(user.user) && !R.isNil(user.user.lastName) ? user.user.lastName : '',
        birthDate: !R.isNil(user.user) && !R.isNil(user.user.birthDate) ? user.user.birthDate : undefined,
        birthPlace: !R.isNil(user.user) && !R.isNil(user.user.birthPlace) ? user.user.birthPlace : '',
        depNumber: !R.isNil(user.user) && !R.isNil(user.user.departmentNumber) ? user.user.departmentNumber : '',
        country: !R.isNil(user.user) && !R.isNil(user.user.country) && user.user.country !== '' ? user.user.country : 'FR'
    });

    const gender = { male: 'Male', female: 'Female' };
    const registerPage = false;
    let loggedIn = !R.isNil(user) && !R.isNil(user.user) && !R.isNil(user.user.phoneNumber) && user.user.phoneNumber !== '';
    let updatingNumber = loggedIn && modifyNumber === true;
    let phoneIsConfirmed = loggedIn ? (ignoreTmp ? auth.phoneConfirmed : true) : auth.phoneConfirmed === true;
    let numberIsSame = !(R.isNil(user.user) || R.isNil(user.user.phoneNumber) || ("+" + credentials.countryCode + credentials.phoneNumber.replace(/ /g, '')) !== user.user.phoneNumber);

    useEffect(() => {
        if (!R.isNil(user.user) && !R.isNil(user.user.phoneNumber)) {
            setTmpPhoneConfirmed(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.user]);

    useEffect(() => {
        if (auth.SMSWasSent === true && !R.isNil(codeRef) && !R.isNil(codeRef.current)) {
            setWasSendOnce(true);
            codeRef.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.SMSWasSent]);

    useEffect(() => {
        if (!R.isNil(credentials)) {
            if (passwordsMatch === true && credentials.password !== credentials.confirmPassword) {
                setPasswordsMatch(false);
            }
            else if (passwordsMatch === false && credentials.password === credentials.confirmPassword) {
                setPasswordsMatch(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [credentials]);

    useEffect(() => {
        if (!R.isNil(credentials) && !R.isNil(credentials.password)) {
            let hasUpper = !R.isNil(credentials.password.match(RegexFields.hasUpperCase));
            let hasLower = !R.isNil(credentials.password.match(RegexFields.hasLowerCase));
            let hasDigits = !R.isNil(credentials.password.match(RegexFields.hasDigits));
            setPasswordRequirements({ ...passwordRequirements, hasDigits: hasDigits, hasLower: hasLower, hasUpper: hasUpper });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [credentials]);



    function handleEnvoyerCode(e) {

        e.preventDefault();
        securityForm.current.classList.add('was-validated');

        const internationalPhoneNumber = parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry);
        if (!internationalPhoneNumber.isValid()) {
            document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
            return;
        }

        if (!R.isNil(user.user) && !R.isNil(user.user.id)) {
            let userToUpdate = {
                id: user.user.id,
                newPhoneNumber: internationalPhoneNumber.number
            };
            dispatch(changePhoneNumber(userToUpdate));
        }
        else {
            dispatch(sendOTPCode(internationalPhoneNumber.number));
        }

        if (ignoreTmp === false) {
            setIgnoreTmp(true);
        }
        setModifyNumber(false);
    }


    function handleInfoForm(e) {
        e.preventDefault();
        const firstFormInputs = document.querySelectorAll("#firstForm input");
        firstFormInputs.forEach(input => {
            input.removeAttribute('id', "input-hide-icon");
        });

        formInfoRef.current.classList.add('was-validated');

        let userToUpdateData = {
            id: user.user.id,
            gender: personalData.gender,
            firstName: personalData.firstName,
            lastName: personalData.lastName,
            birthDate: user.user.birthDate,
            birthPlace: user.user.birthPlace,
            departmentNumber: user.user.depNumber,
            country: user.user.country,
            civilStatus: user.user.civilStatus,
            hasChildren: user.user.hasChildren,
            professionalSituation: user.user.professionalSituation.join(','),
            // phoneNumber: asset.mobile,
            //processNumber: user.user.processNumber
        };

        if (formInfoRef.current.checkValidity() && (credentials.password !== '' && credentials.confirmPassword !== '' && passwordsMatch === true)) {

            let userToUpdateSecurity = {
                id: user.user.id,
                currentPassword: null,
                newPassword: null,
                newEmail: null,
                newPhoneNumber: null,
                otpCode: null
            };

            if (credentials.email !== user.user.email) {
                userToUpdateSecurity.newEmail = credentials.email;
            }

            if (credentials.password !== '' && credentials.password === credentials.confirmPassword) {
                userToUpdateSecurity.currentPassword = credentials.currentPassword;
                userToUpdateSecurity.newPassword = credentials.password;
            }

            dispatch(updateUserSecurity(userToUpdateSecurity));
            dispatch(updateUser(userToUpdateData));

            // setTimeout(() => {
            //     formInfoRef.current.classList.remove('was-validated');
            // }, 5000);
            return;




        }
        if (formInfoRef.current.checkValidity()) {

            firstFormInputs.forEach(input => {
                input.setAttribute('id', "input-hide-icon");
            });

            dispatch(updateUser(userToUpdateData));
        }


    }


    function handleDeleteUser(user) {
        //dispatch(deleteUser(user));
    }


    return (
        <article className="view-calc pt-sm mb-auto">
            {/* <Header roles={roles} /> */}
            <div className="auto-view py-3 pb-lg-0">
                <div className="container-fluid">
                    {/* <Profile passwordRequirements={passwordRequirements} setPasswordRequirements={setPasswordRequirements} registerPage={false}
                    credentials={credentials} setCredentials={setCredentials} credentialsForm={credentialsForm} wasValidated={wasValidated} setWasValidated={setWasValidated} /> */}

                    {

                        <div className="flex-row grid-sm grid-sm-1 grid-md-3 align-items-center mb-4">
                            <div className="h3 font-weight-bold my-auto grid-column-md-2">Données du compte</div>
                            <div className="ml-auto">
                                <button type="button" className="btn p-0 p-md-1 lh-1 align-middle text-danger o-80 o-100--hover" data-toggle="modal" data-target="#deleteUser"><span className="text-body" >Supprimer compte</span><i className="eva eva-trash-outline align-middle fs-lead ml-2"></i></button>
                            </div>
                        </div>
                    }

                    <form ref={securityForm} id="phoneValidation" onSubmit={(e) => e.preventDefault()}>
                        {
                            (((auth.SMSWasSent === false && wasSendOnce === false) || modifyNumber === true) && !auth.isLoading.includes(Loadings.SEND_PHONE_NUMBER)) && (loggedIn ? updatingNumber : true) ?
                                <div className={"form-group container-copy"}>

                                    <label className="h6 font-weight-bolder lh-root" htmlFor="telephone">Quel numéro de téléphone souhaitez-vous utiliser ?</label>
                                    <div className="input-group mb-0">
                                        <select className="custom-select rounded container-paper container-sm-tiny mr-2" id="naturalite" tabIndex={-98} value={!R.isNil(credentials.countryCode) && credentials.countryCode.indexOf("+") > -1 ? credentials.countryCode.substring(1) : credentials.countryCode} onChange={(event) => {

                                            let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
                                            setCredentials({ ...credentials, countryCode: event.target.value, phoneCountry: pc });
                                            setPersonalData({ ...personalData, country: event.target.value });
                                        }}>
                                            {
                                                countryTelData.allCountries.map((country, index) => {
                                                    let dialCode = country.dialCode;
                                                    return (
                                                        <option key={index} value={dialCode}>{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})</option>
                                                    );
                                                })
                                            }
                                        </select>

                                        <input required type="tel" className="form-control rounded" id="phoneNumberInput" placeholder="00 00 00 00 00"
                                            value={parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry) !== undefined ? parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry).formatNational() : credentials.phoneNumber}
                                            aria-describedby="telephoneHelpBlock"
                                            onInput={(e) => {
                                                e.preventDefault();
                                                document.getElementById("phoneNumberInput").setCustomValidity("");
                                                setCredentials({ ...credentials, phoneNumber: e.target.value });
                                            }} />
                                        <div className="w-100 mb-1 d-md-none"></div>
                                        <span className="input-group-text p-0 ml-md-1 border-none bg-none">
                                            <button className="btn btn-info rounded-inherit px-sm" disabled={!R.isNil(credentials) && !R.isNil(user.user) && credentials.countryCode + credentials.phoneNumber.replace(/ /g, '') === user.user.phoneNumber} onClick={(e) => { handleEnvoyerCode(e); }}>
                                                Envoyer code</button>
                                        </span>
                                        {/* <div className={"invalid-feedback"}>
                                            Champs invalide
                                        </div> */}
                                        <div className="invalid-feedback alert bg-alert-danger mt-2 mb-4">
                                            <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                                            <span className="align-middle text-dark o-70">Valider votre numéro de téléphone</span>
                                        </div>
                                    </div>
                                    {
                                        !R.isNil(auth.authError) && auth.authError === "PhoneNumberTaken" ?
                                            <div className="invalid-feedback d-block">
                                                <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                                                <span className="align-middle text-dark o-70">Ce numéro de téléphone est déjà utilisé.</span>
                                            </div>
                                            :
                                            <p className="form-text small text-gray mt-2" id="telephoneHelpBlock"><i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i><span className="align-middle">Nous utiliserons ce numéro pour assurer la sécurité de votre compte.</span></p>
                                    }

                                </div>
                                :

                                auth.phoneConfirmed === false && (loggedIn && ignoreTmp === false ? tmpPhoneConfirmed === false : true) ?
                                    <div className="form-group container-wide">
                                        <label className="h6 font-weight-bolder lh-copy" htmlFor="code">
                                            Nous venons d'envoyer un code de validation par SMS au<br />
                                            <span className="text-primary fs-root">
                                                +{credentials.countryCode} {R.isNil(parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry)) ? '' : parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry).formatNational()}
                                            </span>
                                        </label>

                                        <div className="input-group mb-0">
                                            <input ref={codeRef} type="text" required className="form-control border-common rounded bi-none" id="code" placeholder="Saisissez code" aria-describedby="codeHelpBlock" value={credentials.otpCode}
                                                onInput={(e) => {
                                                    setCredentials({ ...credentials, otpCode: e.target.value });
                                                }} onFocus={() => {
                                                    if (isOnFocus === false) {
                                                        setIsOnFocus(true);
                                                    }
                                                }} onBlur={() => {
                                                    setIsOnFocus(false);
                                                }} />
                                            <span className="input-group-text p-0 ml-1 border-none rounded-sm bg-none">
                                                <button type="button" className="btn btn-info rounded" onClick={(e) => {
                                                    e.preventDefault();
                                                    ///!!!alterar
                                                    //  setCredentials({ ...credentials, phoneIsActive: true });
                                                    const internationalPhoneNumber = parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry);
                                                    if (!internationalPhoneNumber.isValid()) {
                                                        document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
                                                        return;
                                                    }

                                                    dispatch(verifyOTPCode(internationalPhoneNumber.number, credentials.otpCode));
                                                }}>Valider</button>
                                                <button type="button" className="btn btn-white-light rounded ml-1" onClick={(e) => {
                                                    e.preventDefault();
                                                    setModifyNumber(true);
                                                    setCredentials({ ...credentials, otpCode: '' });
                                                    codeRef.current.focus();
                                                }}>Annuler</button>
                                            </span>
                                            {isOnFocus === false && !auth.isLoading.includes(Loadings.SEND_PHONE_NUMBER) ?
                                                <div className={"invalid-feedback"}>
                                                    <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                                                    <span className="align-middle text-dark o-70">Le code n'est pas valide. Veuillez réssayer.</span>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                        {
                                            auth.isLoading.includes(Loadings.SEND_PHONE_NUMBER) || auth.isLoading.includes(Loadings.VERIFYING_NUMBER) ?
                                                <LoadingState alignLeft={true} />
                                                :
                                                ''
                                        }
                                        {auth.SMSWasSent === true ?
                                            <p className="form-text small text-gray mt-2" id="codeHelpBlock">Vous ne l'avez pas reçu ? <span role="button" className="text-primary o-70--hover align-middle font-weight-bold" onClick={(e) => {
                                                e.preventDefault();
                                                setModifyNumber(true);
                                                setCredentials({ ...credentials, otpCode: '' });
                                                codeRef.current.focus();
                                            }}>En recevoir un nouveau</span></p>
                                            : ''
                                        }
                                    </div>
                                    : ''


                        }
                        {(auth.phoneConfirmed && modifyNumber === false) || (loggedIn && (updatingNumber === false && numberIsSame && (tmpPhoneConfirmed && ignoreTmp === false))) ?
                            <div className="container-base pb-4">
                                <div className="block">
                                    <i className="eva eva-phone-outline mr-2 fs-sm lh-root align-middle o-50"></i>
                                    <span className="h3 align-middle text-dark">+{credentials.countryCode} {parsePhoneNumber(credentials.phoneNumber, credentials.phoneCountry).formatNational()}</span>
                                    <span className="badge badge-pill badge-success align-middle ml-2 pill">Validé</span>
                                </div>
                                <div className="block small text-success mb-2">
                                    <i className="eva eva-checkmark-circle-outline mr-1 fs-sm lh-root align-middle"></i>
                                    <span className="align-middle text-dark o-70">Le numéro de téléphone a été activé avec succès.</span>
                                </div>
                                {registerPage === false ? <p className="small text-gray mb-3"><i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i>Les codes de validation sont envoyés par SMS.</p> : ''}
                                {
                                    registerPage === false ?
                                        <button className="btn btn-info rounded-sm py-2 px-4" onClick={(e) => {
                                            e.preventDefault();
                                            setModifyNumber(true);
                                            setCredentials({ ...credentials, otpCode: '' });
                                        }}>Modifier</button>
                                        :
                                        ''
                                }

                            </div>
                            : ''
                        }
                    </form>

                    {loggedIn || ((modifyNumber || auth.phoneConfirmed) && registerPage) ?
                        <form id="formInfo" onSubmit={(e) => handleInfoForm(e)} ref={formInfoRef} noValidate>
                            <div className={"row g-2 mt-4"}>
                                <div className="col-12 col-xl">
                                    <div className="container-xl-base pb-2" ref={credentialsForm} id="firstForm" onSubmit={(event) => {
                                        event.preventDefault();
                                        // if (registerPage === true) {
                                        //     formSubmitRegister(event);
                                        // }
                                        // else {
                                        //     formSubmit(event);
                                        // }
                                    }}>
                                        <div className="form-group">
                                            <label className="h6 font-weight-bolder block" htmlFor="email">Votre e-mail</label>
                                            <input type="email" className="form-control" id="email" placeholder="votreemail@mail.fr" defaultValue={credentials.email} onInput={(event) => {
                                                event.preventDefault();
                                                setCredentials({ ...credentials, email: event.target.value });
                                            }} pattern={RegexFields.email} />
                                            <div className={"invalid-feedback"}>
                                                Champs invalide
                                            </div>
                                        </div>
                                        {
                                            registerPage === true && (R.isNil(user.user) || R.isNil(user.user.id)) ? '' :
                                                <div className="form-group">
                                                    <label className="h6 font-weight-bolder block" htmlFor="confirmpassword">Mot de passe <span className="d-sm-none d-md-inline-block">actuel</span></label>
                                                    <div className="input-group">
                                                        <input required={credentials.password !== '' || credentials.confirmPassword !== ''} type={showCurrentPassword === false ? "password" : ''} className="form-control border-right-0" id="currentPassword" placeholder="mot de passe" pattern={RegexFields.password}
                                                            minLength={8} maxLength={32} onInput={(event) => {
                                                                event.preventDefault();
                                                                setCredentials({ ...credentials, currentPassword: event.target.value });
                                                            }} />
                                                        <div className="input-group-prepend">
                                                            <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                                                <i className={"eva o-30 fs-root lh-0 " + (showCurrentPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showCurrentPassword" onClick={() => { setShowCurrentPassword(!showCurrentPassword); }}></i>
                                                            </div>
                                                        </div>
                                                        <div className={"invalid-feedback"}>
                                                            Champs invalide
                                                        </div>
                                                    </div>
                                                </div>
                                        }

                                        <div className="form-row">
                                            <div className="form-group col-12 col-sm">
                                                <label className="h6 font-weight-bolder block" htmlFor="password">{registerPage === true && (R.isNil(user.user) || R.isNil(user.user.id)) ? "Mot de passe" : "Modifier mot de passe"}</label>
                                                <div className="input-group">
                                                    <input required={registerPage === true && (R.isNil(user.user) || R.isNil(user.user.id)) ? true : (credentials.password !== '' || credentials.confirmPassword !== '')} type={showPassword === false ? "password" : 'text'} className="form-control border-right-0" id="password" placeholder="mot de passe" pattern={RegexFields.password}
                                                        minLength={8} maxLength={32} onInput={(event) => {
                                                            event.preventDefault();
                                                            setCredentials({ ...credentials, password: event.target.value });
                                                        }} />
                                                    <div className="input-group-prepend">
                                                        <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                                            <i className={"eva o-30 fs-root lh-0 " + (showPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showPassword" onClick={() => { setShowPassword(!showPassword); }}></i>
                                                        </div>
                                                    </div>
                                                    <div className={"invalid-feedback"}>
                                                        Champs invalide
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group col">
                                                <label className="h6 font-weight-bolder block" htmlFor="confirmpassword">Confirmation <span className="d-sm-none d-md-inline-block">mot de passe</span></label>
                                                <div className="input-group">
                                                    <input required={registerPage === true ? true : (credentials.password !== '' || credentials.confirmPassword !== '')} type={showConfPassword === false ? "password" : ''} className="form-control border-right-0" id="confirmpassword" placeholder="mot de passe" pattern={RegexFields.password}
                                                        minLength={8} maxLength={32} onInput={(event) => {
                                                            event.preventDefault();
                                                            setCredentials({ ...credentials, confirmPassword: event.target.value });
                                                        }} />
                                                    <div className="input-group-prepend">
                                                        <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                                            <i className={"eva o-30 fs-root lh-0 " + (showPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showConfirmationPassword" onClick={() => { setShowConfPassword(!showConfPassword); }}></i>
                                                        </div>
                                                    </div>
                                                    <div className={"invalid-feedback"}>
                                                        Champs invalide
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"invalid-feedback alert-info alert" + (passwordsMatch === false && wasValidated === true ? ' d-block' : '')}>
                                                Les mots de passe ne sont pas identiques
                                            </div>
                                            <div className={"invalid-feedback alert-danger alert" + (auth.error !== undefined ? ' d-block' : '')}>
                                                {auth.error === 'email' ? 'Il y a déjà un utilisateur avec cet e-mail.' : ''}
                                            </div>
                                        </div>
                                        <input type="submit" hidden={true} />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="card alert-info text-body">
                                        <div className="card-body d-flex align-items-start">
                                            <i className="eva eva-info text-info mr-2 h3 mt-n1"></i>
                                            <div className="flex-grow-1">
                                                <h5 className="small font-weight-bolder text-info text-uppercase">Pour un mot de passe plus sûr</h5>
                                                <p className="small o-50 lh-copy mb-1">Pour atteindre le niveau de sécurité requis, votre mot de passe doit comporter entre 8 et 32 caractères et inclure au moins 3 des types de caractères suivants:</p>
                                                <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasUpper ? '' : ' o-50')}>
                                                    <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasUpper ? ' text-success' : '')}></i>
                                                    <span>une lettre majuscule (A-Z)</span>
                                                </div>
                                                <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasLower ? '' : ' o-50')}>
                                                    <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasLower ? ' text-success' : '')}></i>
                                                    <span>une lettre minuscule (a-z)</span>
                                                </div>
                                                <div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasDigits ? '' : ' o-50')}>
                                                    <i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasDigits ? ' text-success' : '')}></i>
                                                    <span>un chiffre (0-9)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* another form */}

                            </div>
                            <div className="mt-4">
                                <div className="block mt-4" noValidate id="formInfo" >
                                    <h3 className="h3 font-weight-bold mb-4">Mes données</h3>
                                    <section className="block pb-3">
                                        <h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">ETAT CIVIL</h4>
                                        <div className="form-inline mb-3">
                                            <div className="custom-control custom-radio custom-control-inline mr-6">
                                                <input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.female} onChange={(e) => {
                                                    setPersonalData({ ...personalData, gender: gender.female });
                                                }} />
                                                <label className="custom-control-label" htmlFor="Madame">Madame</label>
                                            </div>
                                            <div className="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.male} onChange={(e) => {
                                                    setPersonalData({ ...personalData, gender: gender.male });
                                                }} />
                                                <label className="custom-control-label" htmlFor="Monsieur">Monsieur</label>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col col-xl-4">
                                                <label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
                                                <input required type="text" className="form-control" id="Prenom" defaultValue={personalData.firstName} onChange={(e) => {
                                                    e.preventDefault();
                                                    setPersonalData({ ...personalData, firstName: e.target.value });
                                                }} pattern={RegexFields.nameWithoutNumbers} />
                                            </div>
                                            <div className="form-group col col-xl-4">
                                                <label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
                                                <input required type="text" className="form-control" id="Nom" defaultValue={personalData.lastName} onChange={(e) => {
                                                    e.preventDefault();
                                                    setPersonalData({ ...personalData, lastName: e.target.value });
                                                }} pattern={RegexFields.nameWithoutNumbers} />
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </form>

                        : ''
                    }

                    {/* <form className="block mt-4" noValidate onSubmit={handleSubmitForm} id="formInfo" >
                    <h3 className="h3 font-weight-bold mb-4">Mes données</h3>
                    <section className="block pb-3">
                        <h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">ETAT CIVIL</h4>
                        <div className="form-inline mb-3">
                            <div className="custom-control custom-radio custom-control-inline mr-6">
                                <input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.female} onChange={(e) => {
                                    setPersonalData({ ...personalData, gender: gender.female });
                                }} />
                                <label className="custom-control-label" htmlFor="Madame">Madame</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={personalData.gender === gender.male} onChange={(e) => {
                                    setPersonalData({ ...personalData, gender: gender.male });
                                }} />
                                <label className="custom-control-label" htmlFor="Monsieur">Monsieur</label>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col col-xl-4">
                                <label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
                                <input required type="text" className="form-control" id="Prenom" defaultValue={personalData.firstName} onChange={(e) => {
                                    e.preventDefault();
                                    setPersonalData({ ...personalData, firstName: e.target.value });
                                }} pattern={RegexFields.nameWithoutNumbers} />
                            </div>
                            <div className="form-group col col-xl-4">
                                <label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
                                <input required type="text" className="form-control" id="Nom" defaultValue={personalData.lastName} onChange={(e) => {
                                    e.preventDefault();
                                    setPersonalData({ ...personalData, lastName: e.target.value });
                                }} pattern={RegexFields.nameWithoutNumbers} />
                            </div> */}
                    {/* Show only if admin or super admin */}
                    {/* <div className="form-group col-12 col-md-4">
                                <label className="h6 font-weight-bolder my-auto" htmlFor="Permissions">Role *</label>
                                <select className="custom-select" id="Permissions" tabIndex={-98} >
                                    <option value=""></option>
                                </select>
                            </div> */}
                    {/* </div>
                    </section>
                </form> */}
                </div>
                <div className="container-fluid">
                    <footer className="flex-md-row align-items-center mt-auto mb-sm w-100">
                        <button className="btn btn-info" type='submit' form="formInfo">Sauvegarder</button>
                        <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                    </footer>
                </div>
            </div>
            <DeleteUser selectedUser={user.user} deleteUser={handleDeleteUser} />
        </article>
    );
};